import { Component, OnInit, Inject,OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import 'jspdf-autotable';
import { RollbarService } from '../../../rollbar';
import * as Rollbar from 'rollbar';
import { SessionCheck, generateAlertMessage } from '../../../app-general';
import {Router} from '@angular/router';
declare const require: any;
const jsPDF = require('jspdf');
require('jspdf-autotable');

@Component({
  selector: 'app-download-staff',
  templateUrl: './download-staff.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./download-staff.component.scss']
})
export class DownloadStaffComponent implements OnInit,OnDestroy {

  watcher: Subscription;
  columns: number = 2;
  staffitem;
  RoomName;
  Shifts;
  CurrentTime: any;

  public isExcelDownload: boolean = false;
  public isPDFDownload: boolean = false;

  constructor(private router: Router, mediaObserver: MediaObserver, public thisDialogRef: MatDialogRef<DownloadStaffComponent>, public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any, @Inject(RollbarService) private rollbar: Rollbar) {
    this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
      if (change) {       
        if (change.mqAlias == 'xs') {
          this.columns = 1;
        } 
        else if (change.mqAlias == 'sm') {
          this.columns = 2;
        }                 
      }
    });  
  }

  ngOnInit() {
    var loaderelement = document.getElementsByClassName('loadstaffspinner'); 
        loaderelement[0]["style"].display = "none";
  }

  public onCloseCancel = () => {
    
    this.thisDialogRef.close('Cancel');
    if(!SessionCheck(this.router))
    {
        return;
    }
  }

  downloadStaffExcel(resdata)
  {
    var loaderelement = document.getElementsByClassName('loadstaffspinner'); 
        loaderelement[0]["style"].display = "block";        
        setTimeout(() => { 
          this.downloadStaff_Excel(resdata);
      }, 3); 
  }

  downloadStaff_Excel(staffData) {   
    try
    {
      if(!SessionCheck(this.router))
      {
        this.thisDialogRef.close('Cancel');
          return;
      }
      if (!this.isExcelDownload) {
        this.isExcelDownload = true;
        const downloadStaff = {
          Data: []
        };

      for (let i = 0; i < staffData.length; i++) {
        this.staffitem = staffData[i];  
        
        if(this.staffitem.Gender != null)          
          var staffname = this.staffitem.FirstName + " " + this.staffitem.LastName +" (" + this.staffitem.Gender.substring(0,1) +")";
        else
          var staffname = this.staffitem.FirstName + " " + this.staffitem.LastName;
                    
        if (this.staffitem.RoomName) {
          this.RoomName = this.staffitem.RoomName;
        } else {
          this.RoomName = ' ';
        }
       
        var staffZipcode = "";
        if(this.staffitem.Zip == 0)
          staffZipcode = "";
        else
          staffZipcode = this.staffitem.Zip;
      
          downloadStaff.Data.push({        
          'Staff Name': staffname,
          'Role' : this.staffitem.Designation,
          // 'Gender': this.staffitem.Gender,
          'Email': this.staffitem.Email,       
          'Phone': this.staffitem.Phone,
          'Pager':this.staffitem.PagerNo,                  
          'TagId': this.staffitem.TagId,          
        });
      }

        this.JSONToCSVConvertor(downloadStaff.Data, '', true);
      }
    }
    catch (err) {
      throw new Error('download-staff.component.ts' + ' - downloadStaffExcel() - ' + err.message);
    }    
  }

  JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
    // If JSONData is not an object then JSON.parse will parse the JSON string in an Object
    try {
      var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
         
            var CSV = '';    
     
            if (ShowLabel) {
                var row = "";
                             
                for (var index in arrData[0]) {                                    
                    row += index + ',';
                }
        
                row = row.slice(0, -1);           
                CSV += row + '\r\n';
            }
            
        if(arrData.length>0)
          {        
            for (var i = 0; i < arrData.length; i++) 
            {
                var row = "";     
                for (var index in arrData[i]) 
                {
                    row += '"' + arrData[i][index] + '",';
                }        
                row.slice(0, row.length - 1);                        
                CSV += row + '\r\n';
            }        
            if (CSV == '') {        
              var loaderelement = document.getElementsByClassName('loadstaffspinner'); 
                  loaderelement[0]["style"].display = "none";
                generateAlertMessage(this.dialog, "Invalid data");
                this.isExcelDownload = false;
                return;
            }                                           
            let fileName = 'StaffReport';
            fileName += ReportTitle.replace(/ /g, '_');
          
            var myBlob =  new Blob( [CSV] , {type:'text/html'});
            var url = window.URL.createObjectURL(myBlob);
            var a = document.createElement("a");
            var link = document.body.appendChild(a);
            document.body.appendChild(link);
            link.href = url;
            this.CurrentTime =  new Date().getFullYear() + ('0' + (new Date().getMonth() + 1)).slice(-2) + ('0' + (new Date().getDate())).slice(-2)  + '_' + new Date().getHours() + '_' + new Date().getMinutes() + '_'+  new Date().getSeconds();
            link.download = fileName + '_' + this.CurrentTime + '.csv';             
            link.click();                    
          }
            else        
            {
                var loaderelement = document.getElementsByClassName('loadstaffspinner'); 
                    loaderelement[0]["style"].display = "none";
                generateAlertMessage(this.dialog, "No data available");
               this.isExcelDownload = false;
            }
            var loaderelement = document.getElementsByClassName('loadstaffspinner'); 
                loaderelement[0]["style"].display = "none";
               this.isExcelDownload = false;
      }
      catch (err) {
        throw new Error('download-staff.component.ts' + ' - JSONToCSVConvertor() - ' + err.message);
      }
  }

  downloadStaffPdf(resdata) {
    var loaderelement = document.getElementsByClassName('loadstaffspinner');
    loaderelement[0]["style"].display = "block";
    setTimeout(() => {
      this.downloadStaff_Pdf(resdata);
    }, 3);
  }

  downloadStaff_Pdf(staffData) {
    try {
      if (!SessionCheck(this.router)) {
        this.thisDialogRef.close('Cancel');
        return;
      }
      if (!this.isPDFDownload) {
        this.isPDFDownload = true;
        const resData = [];
        const drows = [''];
        this.CurrentTime = new Date().getFullYear() + ('0' + (new Date().getMonth() + 1)).slice(-2) + ('0' + (new Date().getDate())).slice(-2) + '_' + new Date().getHours() + '_' + new Date().getMinutes() + '_' + new Date().getSeconds();
        const columns = [
          { title: 'Staff Name', dataKey: 'StaffName' },
          { title: 'Role', dataKey: 'Designation' },
          { title: 'Email', dataKey: 'Email' },
          { title: 'Phone', dataKey: 'Phone' },
          { title: 'Pager', dataKey: 'PagerNo' },          
          { title: 'Tag Id', dataKey: 'TagId' },                    
        ];

      if (staffData.length > 0) {          
        for (let i = 0; i < staffData.length; i++) { 
          if(staffData[i].Gender != null)          
            var StaffName = staffData[i].FirstName + " " + staffData[i].LastName +" (" + staffData[i].Gender.substring(0,1) +")";
          else
            var StaffName = staffData[i].FirstName + " " + staffData[i].LastName;
            const Designation = staffData[i].Designation;
            const Email = staffData[i].Email;        
            const Phone = staffData[i].Phone;
            const PagerNo = staffData[i].PagerNo;
            const TagId = staffData[i].TagId;
            var Add="";
            if ( staffData[i].Address !=null)
            {
              Add +=staffData[i].Address  +"\n";
            }
            if (staffData[i].City  !=null)
            {
              Add +=staffData[i].City +"\n";
            }
            if (staffData[i].State !=null)
            {
              Add +=staffData[i].State +"\n";
            }
            if (staffData[i].Country !=null)
            {
              Add +=staffData[i].Country +"\n";
            }
            if (staffData[i].Zip  !=null)
            {
              if(staffData[i].Zip == 0)
                Add += '';
              else
                Add +=staffData[i].Zip ;
            }            
            var Address = Add;           
            var staffShift = this.Shifts;          
            resData.push({ StaffName, Designation, Email, Phone, PagerNo, Address, TagId });          
          }                    
        
        const pdf = new jsPDF('l'); // A4 size page of PDF
        let PdfFileName = 'StaffReport';
        var pageWidth = pdf.internal.pageSize.width || pdf.internal.pageSize.getWidth();
        pdf.text("Staff Report", pageWidth / 2, 10, 'center');
        var options = {
          theme:'grid',
          bodyStyles:{lineColor: [0, 0, 0]},
          tableWidth: 'auto',
          columnWidth: 'wrap',
          showHeader: 'everyPage',
          headStyles: {
              lineWidth: 0.2,
              lineColor: [0, 0, 0],
              textColor: [0, 0, 0],
              fillColor: [169,169,169],
              valign: 'middle',
              halign : 'center',
          },    
          columnStyles: {                                    
            StaffName: {cellWidth: 55,minCellHeight:24},     
            Designation: {cellWidth: 25,minCellHeight:24},
            Email: {cellWidth: 50,minCellHeight:24},
            Phone: {cellWidth: 25,minCellHeight:24},
            PagerNo: {cellWidth: 25,minCellHeight:24},
            Address: {cellWidth: 60,minCellHeight:24},
            TagId: {cellWidth: 25,minCellHeight:24}             
          }, 
          rowPageBreak: 'avoid'
        };
        pdf.autoTable(columns, resData, options);        
        PdfFileName = PdfFileName + '_' + this.CurrentTime + '.pdf';
        pdf.save(PdfFileName);
        var loaderelement = document.getElementsByClassName('loadstaffspinner'); 
        loaderelement[0]["style"].display = "none";
        this.isPDFDownload = false;
      } 
      else 
      {
        var loaderelement = document.getElementsByClassName('loadstaffspinner'); 
            loaderelement[0]["style"].display = "none";
        generateAlertMessage(this.dialog, "No data available");
          this.isPDFDownload = false;
      }      
      var loaderelement = document.getElementsByClassName('loadstaffspinner'); 
          loaderelement[0]["style"].display = "none";
        this.isPDFDownload = false;
      }
    }
    catch (err) {
      throw new Error('download-staff.component.ts' + ' - downloadStaffPdf() - ' + err.message);
    }
  }
ngOnDestroy(){}
}
